module.exports = __webpack_public_path__ + "static/img/南房3.ac6c37ca.jpg";